import { z } from 'zod'

const toolSchema = z.object({
  slug: z.string(), name: z.string(), description: z.string(),
  default_tier: z.enum(['allow', 'confirm']), tier: z.enum(['allow', 'confirm']),
  destructive: z.boolean(),
})

export const toolPermissionsSchema = z.object({
  connection_id: z.string(), toolkit_slug: z.string(), toolkit_name: z.string(),
  display_label: z.string().nullable(), revision: z.number(),
  groups: z.array(z.object({
    id: z.enum(['readonly', 'additional']), title: z.string(), tools: z.array(toolSchema),
    allowed_count: z.number(), requires_approval_count: z.number(),
  })),
  approved_count: z.number(), requires_approval: z.boolean(),
})
